import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useMediaQuery, useTheme as useMUITheme } from '@mui/material';

interface OptionButtonGroupProps {
    options: any[];
    labelField?: string;
    valueField?: string;
    onChange: (value: string) => void;
    value: string;
    needButtonBackground?: boolean;
}

const OptionButtonGroup: React.FC<OptionButtonGroupProps> = ({
                                                                 needButtonBackground,
                                                                 labelField,
                                                                 valueField,
                                                                 options,
                                                                 onChange,
                                                                 value
                                                             }) => {
    const MUITheme = useMUITheme();
    const isSmallScreen = useMediaQuery(MUITheme.breakpoints.down('md'));

    return (
        <Box>
            {options.length <= 5 && !isSmallScreen && (
                // Sostituito theme.spacing.md con il gap nativo = 2 (16px)
                <Box display='flex' gap={2} width={'100%'} flexWrap="wrap">
                    {options.map((option, index) => {
                        const buttonLabel = labelField ? option[labelField] : option;
                        const buttonValue = valueField ? option[valueField] : option;
                        const isSelected = buttonValue === value;

                        return (
                            <Button
                                key={"optionButton-" + index}
                                // Se selezionato è 'contained', altrimenti 'outlined' per mantenere l'effetto trasparente
                                variant={isSelected ? "contained" : "outlined"}
                                color={isSelected ? "primary" : "inherit"}
                                onClick={() => onChange(buttonValue)}
                            >
                                {buttonLabel}
                            </Button>
                        )
                    })}
                </Box>
            )}
        </Box>
    );
}

export default OptionButtonGroup;